import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { DataPointValue, State } from "../../types";
import { newDefaultValue } from "../util";

export type AddGroupAction = Readonly<{
  copyValues: Array<DataPointValue<any>> | null;
  keys: Array<string>;
  taxonomyKeys: Array<string>;
  type: "ADD GROUP";
}>;

export const addGroup = (state: State, action: AddGroupAction): State => {

  if (
    action.keys.length < 1 ||
    action.keys.length !== action.taxonomyKeys.length ||
    (action.copyValues !== null && action.copyValues.length !== action.keys.length)
  ) {
    return state;
  }
  const newValues: State["values"] = {};
  const newBlocks: State["blocks"] = {};
  for (let i = 0; i < action.keys.length; i++) {
    if (action.copyValues === null) {
      newValues[action.keys[i]] = newDefaultValue(action.taxonomyKeys[i], action.keys[i]);
    } else {
      const idRef = action.copyValues[i].idRef;
      if (idRef !== null && idRef in state.blocks) {
        if (!(idRef in newBlocks)) {
          newBlocks[idRef] = {
            ...state.blocks[idRef],
            references: state.blocks[idRef].references.concat([action.keys[i]]),
          };
        } else {
          newBlocks[idRef].references.push(action.keys[i]);
        }
      }
      newValues[action.keys[i]] = {
        ...action.copyValues[i],
        confidence: 1.0,
        valueKey: action.keys[i],
      };
    }
  }
  const values = { ...state.values, ...newValues };
  for (const key of Object.keys(newBlocks)) {
    newBlocks[key] = {
      ...newBlocks[key],
      confidenceClass: getConfidenceClass(newBlocks[key], state.confidenceThreshold, values),
    };
  }
  const blocks =
    Object.keys(newBlocks).length > 0 ? { ...state.blocks, ...newBlocks } : state.blocks;
  return {
    ...state,
    activeValue: action.keys[0],
    blocks,
    modified: true,
    values,
  };
};
